import type { StateCreator } from 'zustand'

import type { Invitation } from '@modules/memberships/memberships.type'

import type { User } from '../user.interface'

import type { UserActionsSlice, UserFetchPatch, UserStore } from './user.type'

type UserSet = Parameters<StateCreator<UserStore, [['zustand/immer', never]], [], UserStore>>[0]

export const createUserActions = (set: UserSet): UserActionsSlice => ({
  setState: (updateState: UserFetchPatch) => set((state) => ({ ...state, ...updateState })),
  setCurrentUser: (user: Partial<User> | User | null) =>
    set((state) => {
      state.currentUser = user as User | null
    }),
  setInvitations: (invitations: Invitation[]) =>
    set((state) => {
      state.invitations = invitations
    }),
  removeInvitation: (invitationId: string) =>
    set((state) => {
      state.invitations = state.invitations.filter((invitation) => invitation.invitationId !== invitationId)
    }),
  setLoading: (loading: boolean) =>
    set((state) => {
      state.loading = loading
    }),
  setError: (error: string | null) =>
    set((state) => {
      state.error = error
    }),
  updateRegionalNames: (firstName: string, lastName: string) =>
    set((state) => {
      if (!state.currentUser?.regionalData) {
        return
      }

      state.currentUser.regionalData.firstname = firstName
      state.currentUser.regionalData.lastname = lastName
    }),
  updateRegionalAvatar: (avatarUrl: string | null) =>
    set((state) => {
      if (!state.currentUser?.regionalData) {
        return
      }

      state.currentUser.regionalData.avatarUrl = avatarUrl
    }),
})
